const Footer = () => {
  return (
    <div className="footer">
      <p> -- last updated: 2026-10 -- </p>
    </div>
  );
};

export default Footer;
